var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: _vm.$conf.sidebar.enabled ? "" : "on-edge",
      attrs: { id: "datesselector" },
    },
    [
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            disabled: this.$store.getters["isUiDisabled"],
            type: "button",
          },
          on: { click: (e) => _vm.prevDate(e) },
        },
        [
          _c("b-icon", {
            attrs: { id: "downloadicon", icon: "arrow-left-bold" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-datepicker",
        {
          staticStyle: { display: "inline" },
          attrs: {
            placeholder: "-",
            position: "is-top-right",
            icon: "calendar-today",
            locale: "en-US",
            "nearby-month-days": false,
            disabled: this.$store.getters["isUiDisabled"],
            "first-day-of-week": 1,
            "date-formatter": _vm.displayFormat,
            "unselectable-dates": _vm.unselectableDates,
            events: _vm.acquisitionEvents,
          },
          model: {
            value: _vm.selectedCalendarDate,
            callback: function ($$v) {
              _vm.selectedCalendarDate = $$v
            },
            expression: "selectedCalendarDate",
          },
        },
        [
          _c(
            "b-dropdown",
            {
              staticStyle: { width: "auto" },
              attrs: { "aria-role": "list", multiple: "" },
              model: {
                value: _vm.selectedCalendarTimes,
                callback: function ($$v) {
                  _vm.selectedCalendarTimes = $$v
                },
                expression: "selectedCalendarTimes",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-dark has-background-black-bis",
                  attrs: { slot: "trigger", type: "button" },
                  slot: "trigger",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("selectTime")))]),
                  _vm._v(" "),
                  _c("b-icon", { attrs: { icon: "menu-down" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.storeTimes, function (item, key) {
                return _c(
                  "b-dropdown-item",
                  { key: key, attrs: { value: item, "aria-role": "listitem" } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(item.split("T")[1].split(".")[0]) +
                        "\n      "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              attrs: { "icon-left": "select-compare" },
              on: {
                click: function ($event) {
                  return _vm.addCurrentLayerToCompare()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("addLayerToComparison")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            disabled: this.$store.getters["isUiDisabled"],
            type: "button",
          },
          on: { click: (e) => _vm.nextDate(e) },
        },
        [
          _c("b-icon", {
            attrs: { id: "downloadicon", icon: "arrow-right-bold" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }